import { createConnectionOptionsFromAddData } from './utils/createConnectionOptionsFromAddData'
import { createPrinter } from './utils/createPrinter'
import { mapSunmiPrinterInfoToInitialFormValues } from './utils/mapSunmiPrinterInfoToInitialFormValues'
import { ConnectionType } from '@/features/print/constants'
import PrinterConfiguration from '@/features/settings/components/PrinterConfiguration'
import { Form } from '@/features/settings/components/PrinterConfiguration/form/types'
import { useAddPrinterActions, useAddPrinterData } from '@/features/settings/contexts/AddPrinter'
import { useAppDispatch } from '@/hooks/redux'
import { addPrinter } from '@/redux/reducers/printers'
import { useRouter } from 'expo-router'
import { FC, useEffect, useMemo } from 'react'

const NewPrinterPage: FC = () => {
    const router = useRouter()

    const dispatch = useAppDispatch()
    const addPrinterData = useAddPrinterData()
    const { unsetData } = useAddPrinterActions()

    const initialFormValues = useMemo<Partial<Form>>(() => {
        if (addPrinterData?.connectionType !== ConnectionType.SunmiDefault) return {}

        return mapSunmiPrinterInfoToInitialFormValues(addPrinterData.printerInfo)
    }, [addPrinterData])

    useEffect(() => {
        if (addPrinterData) return

        router.dismissTo('/settings/printers')
    }, [addPrinterData, router])

    const handleBack = () => {
        router.dismissTo('/settings/printers')
    }

    const handleFormSubmit = async (form: Form) => {
        if (!addPrinterData) return

        const printer = await createPrinter(addPrinterData, form)
        dispatch(addPrinter(printer))
        unsetData()

        router.dismissTo('/settings/printers')
    }

    if (!addPrinterData) {
        return null
    }

    return (
        <PrinterConfiguration
            initialFormValues={initialFormValues}
            connectionOptions={createConnectionOptionsFromAddData(addPrinterData)}
            onBack={handleBack}
            onFormSubmit={handleFormSubmit}
        />
    )
}

export default NewPrinterPage
